import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-protection-benefits',
  templateUrl: './protection-benefits.component.html',
  styleUrls: ['./protection-benefits.component.scss'],
})
export class ProtectionBenefitsComponent {
  /**
   * Emits policy protect open or closed
   */
  @Output() toggledPolicyBenefits: EventEmitter<string> = new EventEmitter();

  @Input() isUpsellAdvantagesOpen = false;
  @Input() showExpandCollapse = true;
  /**
   * Track toggle policy beneifts
   */
  togglePolicyBenefits(event: string) {
    this.toggledPolicyBenefits.emit(event);
  }
}
